import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO } from '../config/config';
import '../styles/footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Integritz Technologies</h3>
            <p className="footer-tagline">Fusion Of Human Values And Technology</p>
            <p>Providing comprehensive IT solutions including hardware, infrastructure, and cloud services to businesses worldwide.</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/services">Our Services & Solutions</Link>
            <Link to="/why-choose-us">Why Choose Us</Link>
            <Link to="/career">Careers</Link>
            <Link to="/contact">Contact Us</Link>
          </div>
          <div className="footer-section">
            <h3>Contact Info</h3>
            <p>📍 {COMPANY_INFO.address}</p>
            <p>📞 {COMPANY_INFO.phone}</p>
            <p>✉ {COMPANY_INFO.email}</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2026 {COMPANY_INFO.name} - All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
